module.exports = __webpack_public_path__ + "img/iot4shm-full.9e23156c.png";